import React from 'react';
import { Box, Typography, Stack, LinearProgress, Paper, Chip } from '@mui/material';
import { Upgrade, Business, History, DoneAll } from '@mui/icons-material';

export const VersionDistributionChart = () => {
  // DUMMY DATA: Scaled for your ~69 companies
  const distributionData = [
    { version: 'v2.14.26', count: 42, isLatest: true },   // 42 companies on latest
    { version: 'v2.14.25', count: 15, isLatest: false },  // 15 companies one build behind
    { version: 'v2.13.0', count: 8, isLatest: false },   // 8 companies on legacy
    { version: 'v2.10.5', count: 3, isLatest: false },   // 3 companies on old
    { version: 'Other', count: 1, isLatest: false },      // 1 company outlier
  ];

  const totalCompanies = distributionData.reduce((sum, item) => sum + item.count, 0);

  return (
    <Paper elevation={0} sx={{ p: 3, borderRadius: 2, border: '1px solid #E2E8F0', height: '100%', bgcolor: '#fff' }}>
      
      {/* ─── HEADER ─── */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
        <Box>
          <Typography variant="subtitle2" sx={{ fontWeight: 800, color: '#64748B' }}>
            APP DISTRIBUTION
          </Typography>
        </Box>
        {/* <Box sx={{ textAlign: 'right' }}>
          <Typography variant="h6" sx={{ fontWeight: 900, color: '#2F727C', lineHeight: 1 }}>
            {totalCompanies}
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 700, color: '#94a3b8' }}>
            ACTIVE TENANTS
          </Typography>
        </Box> */}
      </Stack>

      {/* ─── DATA ROWS ─── */}
      <Stack spacing={2.5}>
        {distributionData.map((item, index) => {
          const percentage = Math.round((item.count / totalCompanies) * 100);
          
          return (
            <Box key={index}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.8 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                  {item.isLatest ? (
                    <DoneAll sx={{ fontSize: 16, color: '#10b981' }} />
                  ) : (
                    <Business sx={{ fontSize: 16, color: '#94a3b8' }} />
                  )}
                  <Typography variant="body2" sx={{ 
                    fontWeight: 800, 
                    fontFamily: 'monospace', 
                    color: item.isLatest ? '#1A3A3F' : '#64748B',
                    fontSize: '0.85rem'
                  }}>
                    {item.version}
                  </Typography>
                  {item.isLatest && (
                    <Chip 
                      label="TARGET" 
                      size="small" 
                      sx={{ 
                        height: 16, 
                        fontSize: '0.6rem', 
                        fontWeight: 900, 
                        bgcolor: 'rgba(16, 185, 129, 0.1)', 
                        color: '#10b981', 
                        border: '1px solid rgba(16, 185, 129, 0.2)',
                        borderRadius: '4px'
                      }} 
                    />
                  )}
                </Stack>
                <Typography variant="caption" sx={{ fontWeight: 800, color: '#1A3A3F' }}>
                  {item.count} <Box component="span" sx={{ color: '#94a3b8', fontWeight: 500 }}>Companies</Box>
                </Typography>
              </Stack>
              
              <LinearProgress 
                variant="determinate" 
                value={percentage} 
                sx={{ 
                  height: 6, 
                  borderRadius: 3, 
                  bgcolor: '#F1F5F9',
                  '& .MuiLinearProgress-bar': {
                    bgcolor: item.isLatest ? '#2F727C' : '#CBD5E1',
                    borderRadius: 3
                  }
                }} 
              />
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
};

// Helper for footer percentage
const percentageOf = (count, total) => Math.round((count / total) * 100);